export default "__VITE_ASSET__C_ONK_o3__"